const initialAssignmentsFilterState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null,
  nbResult: 0,
};

export const getFacturationInfoReducer = (state = initialAssignmentsFilterState, action) => {
  switch (action.type) {
    case "GET_FACTURATION_STATISTICS_PENDING": {
      return {...state, fetched: false, fetching: true};
    }
    case "GET_FACTURATION_STATISTICS_FULFILLED": {
      const {data, nbResult} = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data ? data : [],
        nbResult: nbResult
      };
    }

    case "GET_FACTURATION_STATISTICS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        items: [],
        nbResult: 0,
        error
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/index/statistics/getFacturationInfo.js